import { Link } from "react-router-dom";
import { Paths } from "@/paths";
import type { Analytics } from "@models/analytics.model";

interface TodoItem {
    todo_id: number;
    todo_name: string;
    todo_status: string;
    todo_due_date: string | null;
    assigned_to_employee_id?: number;
}

const PREVIEW_LIMIT = 5;

function isPastDue(due: string | null): boolean {
    if (!due) return false;
    const d = new Date(due + "T00:00:00");
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return d < today;
}

function daysPastDue(due: string): number {
    const d = new Date(due + "T00:00:00");
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return Math.floor((today.getTime() - d.getTime()) / 86_400_000);
}

function sortByUrgency(a: TodoItem, b: TodoItem): number {
    // Past-due first, then closest due date, then nulls last.
    const aDue = a.todo_due_date ? new Date(a.todo_due_date).getTime() : Infinity;
    const bDue = b.todo_due_date ? new Date(b.todo_due_date).getTime() : Infinity;
    return aDue - bDue;
}

export default function TodosTile({ analytics }: { analytics: Analytics }) {
    const all: TodoItem[] = analytics.charts?.["todos-list"] ?? [];
    const open = all.filter((t) => t.todo_status !== "Done");
    const preview = [...open].sort(sortByUrgency).slice(0, PREVIEW_LIMIT);

    return (
        <div className="dash-card">
            <div className="dash-card__head">
                <span className="dash-card__title">Todos</span>
                <span style={{ fontSize: 12, color: "#6b7280" }}>
                    {open.length} open
                </span>
            </div>
            <div className="dash-card__body" style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ flex: 1 }}>
                    {preview.length === 0 ? (
                        <div className="dash-empty">No todos at this time.</div>
                    ) : (
                        preview.map((item) => (
                            <div key={item.todo_id} className="todo-row">
                                <div>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span style={{ fontWeight: 600, fontSize: 14 }}>{item.todo_name || "—"}</span>
                                        {isPastDue(item.todo_due_date) && (
                                            <span className="todo-past-due">
                                                {daysPastDue(item.todo_due_date!)}d overdue
                                            </span>
                                        )}
                                    </div>
                                    <span style={{ fontSize: 12, color: "#6b7280" }}>
                                        <i className="bi bi-alarm" />&nbsp;{item.todo_status}
                                        {item.todo_due_date && (
                                            <>
                                                &nbsp;&middot;&nbsp;
                                                <i className="bi bi-calendar" />&nbsp;Due {item.todo_due_date}
                                            </>
                                        )}
                                    </span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
                <Link to={`${import.meta.env.BASE_URL}${Paths.MY_TODOS}`} className="view-all-link" style={{ marginTop: "auto" }}>
                    View all →
                </Link>
            </div>
        </div>
    );
}
